import apiClient from './client';

export type KeywordResourceType = 'product' | 'page' | 'store';
export type KeywordIntent = 'informational' | 'commercial' | 'transactional' | 'navigational';
export type KeywordDifficulty = 'low' | 'medium' | 'high';

export interface Keyword {
  phrase: string;
  intent: KeywordIntent;
  difficulty: KeywordDifficulty;
  monthly_volume_estimate: string;
}

export interface ContentAngle {
  angle: string;
  description: string;
}

export interface KeywordSet {
  id: number;
  resource_type: KeywordResourceType;
  resource_type_label: string;
  resource_id: number | null;
  resource_title: string;
  primary_keyword: string;
  keyword_count: number;
  keywords: Keyword[];
  content_angles: ContentAngle[];
  ai_model: string | null;
  prompt_tokens: number | null;
  completion_tokens: number | null;
  cost_usd: number;
  created_at: string;
  updated_at: string;
}

export interface PaginatedKeywordSets {
  data: KeywordSet[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface GenerateKeywordsParams {
  resource_type: KeywordResourceType;
  resource_id?: number;
}

const BASE = '/keywords';

export const keywordsApi = {
  list: (params?: { resource_type?: KeywordResourceType; page?: number }) =>
    apiClient.get<{ success: boolean; data: KeywordSet[]; meta: PaginatedKeywordSets['meta'] }>(BASE, { params }).then((r) => r.data),

  generate: (params: GenerateKeywordsParams) =>
    apiClient.post<{ success: boolean; data: KeywordSet }>(`${BASE}/generate`, params).then((r) => r.data.data),

  find: (id: number) =>
    apiClient.get<{ success: boolean; data: KeywordSet }>(`${BASE}/${id}`).then((r) => r.data.data),

  destroy: (id: number) => apiClient.delete(`${BASE}/${id}`),
};
